import { render, staticRenderFns } from "./DownloadFile.vue?vue&type=template&id=5897c03d&scoped=true&"
import script from "./DownloadFile.vue?vue&type=script&lang=js&"
export * from "./DownloadFile.vue?vue&type=script&lang=js&"
import style0 from "./DownloadFile.vue?vue&type=style&index=0&id=5897c03d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5897c03d",
  null
  
)

export default component.exports